<template>
    <div>
        <b-tabs content-class="slu-dashboard-cohort-index-content"
                class="slu-cohort-tabs apprentice-tab"
                v-model="activeTab"
                @input="updateTabIndex">
            <b-tab title="Modules">
                <design-2021-slu-cohort-modules-index-tab-component
                    :slu-school-settings-in="sluSchoolSettingsIn"
                    :slu-labels-in="sluLabelsIn"
                    :slu-course-in="sluCourseIn"
                    :slu-cohort-in="dynamicSluCohort">
                </design-2021-slu-cohort-modules-index-tab-component>
            </b-tab>

            <b-tab :title="$t('slu_dashboard.students')">
                <design-2021-slu-cohort-students-tab-component
                    :slu-course-in="sluCourseIn"
                    :slu-cohort-in="dynamicSluCohort"
                    :las-groups-in="lasGroupsIn"
                    :las-main-groups-in="lasMainGroupsIn">
                </design-2021-slu-cohort-students-tab-component>
            </b-tab>

            <b-tab :title="$t('slu_dashboard.classes')" lazy v-if="$authUser.hasRoleOrAdmin('slu')">
                <design-2021-slu-cohort-las-groups-tab-component
                    :slu-cohort-in="dynamicSluCohort"
                    :las-groups-in="lasGroupsIn"
                    :las-main-groups-in="lasMainGroupsIn"
                    @updateCohort="updateCohort($event)">
                </design-2021-slu-cohort-las-groups-tab-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: "design-2021-slu-dashboard-cohort-index-component",
    props: ['sluCourseIn', 'sluCohortIn','lasGroupsIn','lasMainGroupsIn','sluSchoolSettingsIn', 'sluLabelsIn'],
    data() {
        return {
            sluCohort: this.sluCohortIn,
            activeTab: 0,
            storageName: `slu-cohort-${this.$authUser.id}-${this.sluCohortIn.id}-tab`,
            openGroupModal: false,
        }
    },
    computed: {
        dynamicSluCohort() {
            return this.sluCohort;
        }
    },

    methods: {
        updateCohort(cohort){
            this.sluCohort = cohort
        },

        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.setItem(this.storageName, tabIndex);
        },
    },

    created() {
        if(localStorage.getItem(this.storageName)){
            this.activeTab = parseInt(localStorage.getItem(this.storageName));
        }
    }
}
</script>

<style scoped>

</style>
